import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueRouter from "vue-router";
import "./assets/css/main.css";
import { store } from "./store/store";
import "@koumoul/vjsf/lib/VJsf.css";
import "ant-design-vue/dist/antd.css";
import TreeSelect from "ant-design-vue/lib/tree-select";
import VueGoogleCharts from "vue-google-charts";
import VueExpandableImage from "vue-expandable-image";
import VueClipboard from "vue-clipboard2";
import Vue2Editor from "vue2-editor";

Vue.use(Vue2Editor);
Vue.use(VueExpandableImage);

Vue.component(TreeSelect.name, TreeSelect);
Vue.config.devtools = true
Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VueGoogleCharts);
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

import Home from "./components/pages/Home";
import Landing from "./components/pages/Landing";
import ItemSearch from "./components/pages/ItemSearch";
import WriteDescriptions from "./components/pages/WriteDescriptions";
import Categories from "./components/pages/Categories";
// import NestedDropdown from "./components/molecules/NestedDropdown";
import Discounts from "./components/pages/Discounts";
import Brands from "./components/pages/Brands";
// import Materials from "./components/pages/Materials";
import Colors from "./components/pages/Colors";
import Settings from "./components/pages/Settings";
import Statistics from "./components/pages/Statistics";
import ListingSupervision from "./components/pages/ListingSupervision";
import Login from "./components/pages/Login";
import Users from "./components/pages/Users";
import SElocations from "./components/pages/SElocations";
import Supply from "./components/pages/Supply";
import FlashSales from "./components/pages/FlashSales";
import ExportToPlatform from "./components/Platforms/ExportToPlatform";
import PlatformUploadHistory from "./components/pages/PlatformUploadHistory";
import PlatformMapping from "./components/pages/PlatformMapping";
// import ExportPigult  from "./components/pages/ExportPigult.vue"
import TranslateWorld from "./components/Pigult/TranslateWorld.vue";
import WholeSales from "./components/pages/WholeSales.vue";
import SettingWH from "./components/pages/SettingsWH.vue";
import WHBrands from "./components/pages/WHBrands.vue"
import WHCategories from "./components/pages/WHCategories.vue"
import WHSeasons from "./components/pages/WHSeasons.vue"
import WHGender from "./components/pages/WHGender.vue"
import WHcolors from "./components/pages/WHColors.vue"
import WHlanguage  from "./components/pages/WHLanguage.vue"
import WHPhotos  from "./components/pages/WHPhoto.vue"
let permissions = [];

if (localStorage.getItem("permissions") !== null) {
  permissions = localStorage.getItem("permissions").split(",");
}

const router = new VueRouter({
  mode: "history",
  base: __dirname,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { requiresAuth: true },
      // Logged-out visitors see the landing page; SSO tokens and logged-in users pass through to the app.
      async beforeEnter(to, from, next) {
        if (localStorage.getItem("token") || to.query["bc-auth-token"]) {
          next();
        } else {
          next({ name: "Landing" });
        }
      },
    },
    {
      path: "/welcome",
      name: "Landing",
      component: Landing,
      meta: { title: "ProductsDB | AI-Native Product Data Platform" },
      beforeEnter(to, from, next) {
        if (localStorage.getItem("token")) next({ name: "home" });
        else next();
      },
    },
    {
      path: "/registration",
      name: "Registration",
      component: ItemSearch,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can register products")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/wholesales-products",
      name: "wholesales-products",
      component: WholeSales,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can register products")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/SElocations",
      name: "SE Locations",
      component: SElocations,
      meta: { requiresAuth: true },
      // async beforeEnter(to, from, next) {
      //   if (to.matched.some((record) => record.meta.requiresAuth)) {
      //     if (!permissions.includes("Can manage configuration")) {
      //       next({
      //         name: "home",
      //       });
      //     } else {
      //       next();
      //     }
      //   } else {
      //     next();
      //   }
      // },
    },
    {
      path: "/descriptions",
      name: "Descriptions",
      component: WriteDescriptions,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can write descriptions")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/categories",
      name: "Categories",
      component: Categories,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can manage configuration")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/wh-categories",
      name: "WHCategories",
      component: WHCategories,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can manage configuration")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path : "/photos/:id",
      name : "WHPhotos",
      component : WHPhotos
    },
    {
      path: "/wh-seasons",
      name: "WHSeasons",
      component: WHSeasons,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can manage configuration")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/discounts",
      name: "Discounts",
      component: Discounts,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can manage configuration")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/brands",
      name: "Brands",
      component: Brands,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can manage configuration")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/wh-brands",
      name: "WHBrands",
      component: WHBrands,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can manage configuration")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
      { path: "/wh-gender",
      name: "WHGender",
      component: WHGender,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can manage configuration")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    
    { path: "/wh-colors",
    name: "WHColors",
    component: WHcolors,
    meta: { requiresAuth: true },
    async beforeEnter(to, from, next) {
      if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (!permissions.includes("Can manage configuration")) {
          next({
            name: "home",
          });
        } else {
          next();
        }
      } else {
        next();
      }
    },
  },  { path: "/wh-languages",
  name: "WHlanguages",
  component: WHlanguage,
  meta: { requiresAuth: true },
  async beforeEnter(to, from, next) {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (!permissions.includes("Can manage configuration")) {
        next({
          name: "home",
        });
      } else {
        next();
      }
    } else {
      next();
    }
  },
},
    {
      path: "/settings",
      name: "Settings",
      component: Settings,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can manage configuration")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },

    {
      path: "/wh-settings",
      name: "SettingWH",
      component: SettingWH,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can manage configuration")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/statistics",
      name: "Statistics",
      component: Statistics,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can view KPI dashboard")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/colors",
      name: "Colors",
      component: Colors,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can manage configuration")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/listingsupervision",
      name: "Listings Supervision",
      component: ListingSupervision,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can view listings")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { requiresAuth: true, title: "ProductsDB | Login" },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (localStorage.getItem("token")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/users",
      name: "Users",
      component: Users,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can manage users")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/supply",
      name: "Supply",
      component: Supply,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can manage supply")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/flashsales",
      name: "Flash Sales",
      component: FlashSales,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Flash selling")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/platformExport/:platformName",
      name: "platformExport",
      component: ExportToPlatform,
      props: true,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can view listings")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/export/pigult",
      name: "exportPiguLt",
      component: TranslateWorld,
      props: true,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can view listings")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
    {
      path: "/platformUploadHistory",
      name: "platformUploadHistory",
      component: PlatformUploadHistory,
      props: true,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can view listings")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },

    {
      path: "/platformMapping",
      name: "platformMapping",
      component: PlatformMapping,
      props: true,
      meta: { requiresAuth: true },
      async beforeEnter(to, from, next) {
        if (to.matched.some((record) => record.meta.requiresAuth)) {
          if (!permissions.includes("Can view listings")) {
            next({
              name: "home",
            });
          } else {
            next();
          }
        } else {
          next();
        }
      },
    },
  ],
});

//navigation guard
// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (!localStorage.getItem("token") && to.path !== "/login") {
//       next({
//         name: "Login",
//       });
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
